import React, { Component } from 'react';
import PropTypes from 'prop-types';
import random from 'lodash/random';
import styled from 'styled-components';

import OnboardingStore from 'admin/stores/OnboardingStore';

import Pulse from './Pulse';
import Modal from './Modal';

const Container = styled.aside`
  z-index: 2;
  position: relative;
  white-space: normal;
  text-align: left;
  outline: 0;
`;

const BUTTON_LABELS = ['Got it', 'Awesome', 'Ok', 'Thanks', 'Cool'];

class Hotspot extends Component {
  onHotspotClicked = this.onHotspotClicked.bind(this);
  onPulseClicked = this.onPulseClicked.bind(this);
  onDismissButtonClicked = this.onDismissButtonClicked.bind(this);
  onConfirmButtonClicked = this.onConfirmButtonClicked.bind(this);
  containerRef = React.createRef();
  state = {
    showModal: false,
    completed: true
  };

  componentDidMount() {
    this.setState({
      anchorClass: this.props.anchor,
      showModal: this.props.showModalOnInit
    });

    if (this.props.getStateFromStore) {
      OnboardingStore.getState().then((state) => {
        if (!state.hotspots.completed[this.props.hotspotId]) {
          this.setState({ completed: false });
        }
      });
    } else {
      this.setState({ completed: false });
    }
  }

  onHotspotClicked(event) {
    event.stopPropagation();
  }

  onPulseClicked() {
    this.showModal();
  }

  showModal() {
    this.setState({
      anchorClass: this.getAdjustedPosition(this.props.anchor, this.containerRef),
      showModal: true
    });
    window.dataLayer.push({
      event: `admin_hotspot-${this.props.hotspotId}-open`
    });
  }

  onConfirmButtonClicked(event) {
    event.stopPropagation();

    if (!this.props.preserveModalOnConfirm) {
      this.setState({ completed: true });
    }

    if (this.props.getStateFromStore) {
      this.saveCompletedState();
    }

    if (this.props.onConfirmButtonClicked) {
      this.props.onConfirmButtonClicked();
    }
  }

  onDismissButtonClicked(event) {
    event.stopPropagation();
    this.setState({ completed: true });
    if (this.props.getStateFromStore) {
      this.saveCompletedState();
    }
  }

  saveCompletedState() {
    OnboardingStore.dismissHotspot(this.props.hotspotId);
    window.dataLayer.push({
      event: `admin_hotspot-${this.props.hotspotId}-dismiss`
    });
  }

  getAdjustedPosition(position, containerRef) {
    // naively positions tooltip for best fit by updating anchorClass
    const hotspotRect = containerRef.current.getBoundingClientRect();
    const windowWidth = window.innerWidth;
    const fromLeft = hotspotRect.left;
    const fromRight = windowWidth - hotspotRect.right;
    let anchor = position.split('-');

    // switch left/right if too close to edge
    if (fromRight < fromLeft && fromRight < 320 && anchor.indexOf('left') > -1) {
      anchor = anchor.map(pos => (pos === 'left' ? 'right' : pos));
    } else if (fromLeft < fromRight && fromLeft < 300 && anchor.indexOf('right') > -1) {
      anchor = anchor.map(pos => (pos === 'right' ? 'left' : pos));
    }

    // for left-/right- anchors, switch to top-/bottom- on narrower screens
    if (windowWidth < 960 && ['left', 'right'].indexOf(anchor[0]) > -1) {
      anchor = anchor.reverse();
    }

    return anchor.join('-');
  }

  render() {
    return this.state.completed ? null : (
      <Container className="hotspot" onClick={this.onHotspotClicked} ref={this.containerRef}>
        {this.props.hotspotShowPulse && <Pulse onClick={this.onPulseClicked} />}
        {this.state.showModal &&
          <Modal
            anchorClass={this.state.anchorClass}
            title={this.props.modalTitle}
            description={this.props.modalDescription}
            confirmButtonLabel={this.props.confirmButtonLabel}
            onDismissButtonClicked={this.onDismissButtonClicked}
            onConfirmButtonClicked={this.onConfirmButtonClicked}
            onSecondaryButtonClicked={this.props.onSecondaryButtonClicked}
            secondaryButtonLabel={this.props.secondaryButtonLabel}
          />
        }
      </Container>
    );
  }
}

Hotspot.propTypes = {
  hotspotId: PropTypes.string.isRequired,
  modalTitle: PropTypes.string.isRequired,
  modalDescription: PropTypes.string.isRequired,
  anchor: PropTypes.string.isRequired,
  getStateFromStore: PropTypes.bool.isRequired,
  hotspotShowPulse: PropTypes.bool.isRequired,
  showModalOnInit: PropTypes.bool.isRequired,
  preserveModalOnConfirm: PropTypes.bool,
  onConfirmButtonClicked: PropTypes.func,
  confirmButtonLabel: PropTypes.string,
  onSecondaryButtonClicked: PropTypes.func,
  secondaryButtonLabel: PropTypes.string
};

Hotspot.defaultProps = {
  confirmButtonLabel: BUTTON_LABELS[random(BUTTON_LABELS.length - 1)],
  hotspotShowPulse: true,
  preserveModalOnConfirm: false,
  getStateFromStore: true,
  showModalOnInit: false
};

export default Hotspot;


// WEBPACK FOOTER //
// ./src/app/admin/components/Hotspot/index.js